// recova GmbH – API-Client (axios, Cookie-Auth), Status-Labels/Farben, Helper (EUR, Upload).
import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const API = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const fileUrl = (p) => (p ? (p.startsWith("http") ? p : `${BACKEND}${p}`) : null);

export const fmtErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Unbekannter Fehler";
};

export const STATUS_LABELS = {
  angefragt: "Angefragt",
  terminvorschlag: "Terminvorschlag gesendet – Warten auf Kunde",
  termin_vereinbart: "Termin vereinbart",
  techniker_unterwegs: "Techniker unterwegs",
  vor_ort: "Techniker vor Ort – Arbeit läuft",
  teil_reserviert_halle: "Ersatzteil auf Lager (Halle) – Bereit für Zweittermin",
  wartet_auf_lieferant: "Wartet auf Lieferant",
  bereit_fuer_zweittermin: "Ersatzteil eingetroffen – Bereit für Zweittermin",
  abgeschlossen: "Erfolgreich abgeschlossen",
  totalschaden: "Totalschaden / Reparatur abgelehnt",
  storniert: "Storniert (Kundenwunsch)",
};

export const STATUS_COLORS = {
  angefragt: "bg-slate-100 text-slate-700 border-slate-300",
  terminvorschlag: "bg-purple-50 text-purple-700 border-purple-300",
  termin_vereinbart: "bg-cyan-50 text-[#028090] border-[#028090]/30",
  techniker_unterwegs: "bg-amber-50 text-amber-700 border-amber-300",
  vor_ort: "bg-[#028090] text-white border-[#028090]",
  teil_reserviert_halle: "bg-emerald-50 text-[#1b4332] border-[#1b4332]/30",
  wartet_auf_lieferant: "bg-orange-50 text-orange-700 border-orange-300",
  bereit_fuer_zweittermin: "bg-emerald-50 text-[#1b4332] border-[#1b4332]/30",
  abgeschlossen: "bg-[#1b4332] text-white border-[#1b4332]",
  totalschaden: "bg-red-50 text-red-700 border-red-300",
  storniert: "bg-slate-100 text-slate-500 border-slate-300",
};

export const eur = (v) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(v || 0);

export const uploadPhoto = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const r = await API.post("/upload", fd);
  return r.data.url;
};
